import React, { useMemo } from 'react';
import { image } from '../../../utils/data/baseUrl';
import { useTranslation } from '../../../translations';

const Preview = React.forwardRef(function Preview({ img, type, rewardBonuses }, ref) {
  const { t } = useTranslation();

  const _image = useMemo(() => {
    if (img) return img;
    else
      return type === 'Promocode'
        ? image('reward/promocode.png')
        : rewardBonuses
        ? image(`reward/${rewardBonuses}.png`)
        : null;
  }, [img, type]);

  return (
    <>
      {_image && (
        <div className={'w-modal__preview'} ref={ref}>
          <img src={_image} alt={t('other.reward')} />
        </div>
      )}
    </>
  );
});
export default Preview;
Preview.propTypes = {};
